import { TFunction } from 'i18next';

export function translatedValueEnum(t: TFunction<'translation', undefined>, key: string): Record<string, string> {
  const block = t(key, { returnObjects: true }) as unknown;
  return typeof block === 'object' && block !== null ? (block as Record<string, string>) : {};
}
